import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import mockData from '../mock';

const ProcessSection = () => {
  const { process } = mockData;

  return (
    <section id="process" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Simple 6-Step Process
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From consultation to savings - we handle everything
          </p>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-orange-500 via-yellow-400 to-green-500 transform -translate-x-1/2"></div>

          {/* Steps */}
          <div className="space-y-12">
            {process.map((step, index) => (
              <div
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content Card */}
                <div className="lg:w-5/12">
                  <div className="bg-white rounded-2xl p-8 shadow-xl card-hover border-l-4 border-orange-500">
                    <div className="flex items-start justify-between mb-4">
                      <h3 className="text-2xl font-bold text-gray-900">
                        {step.title}
                      </h3>
                      <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                        {step.duration}
                      </span>
                    </div>
                    <p className="text-gray-600 text-lg leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Step Number Circle */}
                <div className="relative lg:w-2/12 flex justify-center">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-full flex items-center justify-center shadow-2xl border-4 border-white z-10">
                    <span className="text-white font-bold text-3xl">{step.step}</span>
                  </div>
                </div>

                {/* Spacer */}
                <div className="lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-green-500 to-green-600 rounded-full px-8 py-4 shadow-2xl">
            <CheckCircle2 className="w-8 h-8 text-white" />
            <span className="text-white font-bold text-xl">
              Total Time: 7-10 Days Only!
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;